export default "__VITE_ASSET__NCAVwcqY__"